import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import BlockRoundIcon from "@rsuite/icons/BlockRound";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import React, { useRef, useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import ViewCompanyProductModal from "./ViewCompanyProduct";

const CompanyProductSingleAction = ({
  productData,
  onDeleteProduct,
  permission,
  ...props
}: {
  productData: any;
  onDeleteProduct?: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const productRef = useRef({});
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedProductId = encryptUrl(`${productData.id}`);

  const productUpdateLink = ContentRoutes.UPDATE_PRODUCT.replace(
    ":id",
    ecryptedProductId.toString()
  );
  const navigate = useNavigate();
  const publishText =
    productData.status == statusArr.active
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t("CONFIRM_ACTION", {
    action:
      productData.status == statusArr.active
        ? t("UNPUBLISH").toLowerCase()
        : t("PUBLISH").toLowerCase(),
    entity: t("PRODUCT").toLowerCase(),
  });
  const publishIcon =
    productData.status == statusArr.inactive ? (
      <BlockRoundIcon />
    ) : (
      <CheckRoundIcon />
    );

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      setOpenModalByName(eventKey);
      dispatch(setActionData(productData));
      onClose();
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-product"}>{t("VIEW")}</Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  const handleEditAction = (data: any) => {
    dispatch(setActionData(data));
    const ecryptedProductId = encryptUrl(`${data.id}`);
    const productEditLink =
      ContentRoutes.UPDATE_PRODUCT.replace(
        ":id",
        ecryptedProductId.toString()
      ) +
      "?prod_type=" +
      data?.product_type_id;
    navigate(productEditLink);
  };

  return (
    <div>
      {permission.update && (
        <>
          <IconButton
            appearance="subtle"
            onClick={() => {
              handleEditAction(productData);
            }}
            title={t("EDIT")}
            icon={<Edit />}
          />
        </>
      )}
      {permission.delete && (
        <>
          <IconButton
            onClick={() => {
              productRef.current = productData;
              setOpenDeleteModal(true);
            }}
            icon={<Trash />}
            title={t("DELETE")}
            size="md"
          />
        </>
      )}
      {permission.publish && (
        <>
          <IconButton
            onClick={() => {
              productRef.current = productData;
              setOpenPublishModal(true);
              setPublishMessage(pMessage);
            }}
            icon={publishIcon}
            title={publishText}
            size="md"
          />
        </>
      )}
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-product" && (
        <ViewCompanyProductModal
          status={openModalByName === "view-product" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            if (onDeleteProduct) onDeleteProduct(productRef);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("PRODUCT").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
    </div>
  );
};

export default CompanyProductSingleAction;
